// "View as teacher" / "View as student" (2026-09-25): the admin page's way into
// view mode. Opens the person's real dashboard in this tab; the view-mode bar's
// "Back to admin" returns to the page the admin came from. A teacher's
// "View as student" (2026-10-27) passes viewer="Teacher" and the class the
// student is in; the bar's "Back to my class" returns them.
import { Eye } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { beginViewAs, homeOf, isViewAsId } from './viewAsStore';

// labelClassName wraps the words in a span (e.g. hidden on phones, icon only);
// the button keeps them as its name.
export default function ViewAsButton({ kind, person, school = null, viewer = 'Admin', classId = null, className = 'ad-button', labelClassName = null }) {
  const navigate = useNavigate();
  const location = useLocation();
  // An id the admin API would refuse gets no button (beginViewAs would throw).
  if (!isViewAsId(person?.id)) return null;
  // A teacher views only a student, in a named class.
  if (viewer === 'Teacher' && (kind !== 'student' || !classId)) return null;
  const open = () => {
    beginViewAs({
      viewer,
      classId,
      kind,
      id: person.id,
      name: person.name,
      email: person.email || null,
      school,
      grade: person.grade ?? null,
      returnTo: `${location.pathname}${location.search}`,
    });
    navigate(homeOf(kind));
  };
  const label = kind === 'teacher' ? 'View as teacher' : 'View as student';
  return (
    <button type="button" className={className} onClick={open} aria-label={labelClassName ? label : undefined} title={labelClassName ? label : undefined}>
      <Eye size={16} strokeWidth={2} aria-hidden="true" />
      {labelClassName ? <span className={labelClassName}>{label}</span> : label}
    </button>
  );
}
